import { trackSegmentAndGAEvent } from '@zoopla/tracking';

export const trackQuestionClose = (questionName: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'situation',
            eventAction: 'click',
            eventLabel: `${questionName} close`
        },
        page
    );
};
